<template lang="html">
    <div class="row">

        <!-- Sales channel selector -->
        <div class="col-sm-12" v-for="salesChannel in allChannels">
            <div class="d-flex align-items-center justify-content-between">

                <div class="">
                    <div class="d-flex align-items-center">
                        <checkbox v-model="salesChannel.isActive" @input="salesChannelStateChanged(salesChannel)" class="mt-1">
                            {{salesChannel.channelName}}
                        </checkbox>

                        <div v-if="salesChannel.channelType == 50" class="ml-2">
                            <v-select :options="agentsChannelOptions" :disabled="!salesChannel.isActive" v-model="selectedAgentsChannelOptions" @input="agentsChannelOptionsChanged($event, salesChannel)"></v-select>
                        </div>

                    </div>

                    <div v-if="salesChannel.channelType == 50">

                        <div class="d-flex flex-column pRelative ml-4" v-if="customAgentSelction">

                            <agent-white-list class="mt-2" :allowedIdArray="scheduleTask.agentIdList" :startAllSelected="customAgentListSelectAll" @input="agentListChanged"></agent-white-list>
                        </div>

                    </div>
                </div>

            </div>

        </div>


        <!-- Type -->
        <div class="col-sm-12 mt-4">
            <h5>Delivery</h5>
            <div class="row">
                <div class="col-sm-12">
                    <checkbox v-model="scheduleTask.isToDeliverDocumentToEachEntity" class="mt-1">
                        Send report + invoice to each agent / OTA
                    </checkbox>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import vSelect from 'vue-select'

import agentWhiteList from '@/components/inventory/products/components/AgentWhiteList'

export default {
    data: function () {
        return {
            allChannels: [],
            agentsChannelOptions: [
                {
                    label: 'All Agents',
                    value: false
                },
                {
                    label: 'Agent Selection',
                    value: true
                }
            ],
            selectedAgentsChannelOptions: {
                label: 'All Agents',
                value: false
            },
            customAgentSelction: false, // temp
            customAgentListSelectAll: false, //temp
            startAllSelected: false,
            whiteList: [],
        }
    },
    created: function () {
        this.allChannels = JSON.parse(JSON.stringify(this.getSalesChannelsForNewProduct))
        this.setActiveCorrectChannels()
    },
    props: {
        scheduleTask:{
            type: Object
        }
    },
    computed: {
        ...mapGetters([
            'getSalesChannelsForNewProduct'
        ]),
    },
    methods:{
        setActiveCorrectChannels: function () {
            for (let channel of this.allChannels) {
                channel.isActive = this.scheduleTask.channelIdList.includes(channel.channelId)
            }

            // enable "Agent Selection" if there are any agents selected
            if(this.scheduleTask.agentIdList.length > 0){
                this.selectedAgentsChannelOptions = this.agentsChannelOptions.find(option => {
                    return option.value == true
                })
            }
        },
        agentListChanged: function (e) {
            let idArray = e.filter(item => {
                return item.selected == true
            }).map(item => {
                return item.id
            })
            
            this.scheduleTask.agentIdList = idArray
        },
        salesChannelStateChanged: function (channel) {
            if(channel.channelType == 50 && channel.isActive == false){
                this.selectedAgentsChannelOptions = this.agentsChannelOptions[0]
            }

            this.scheduleTask.channelIdList = this.allChannels.filter(salesChannel => {return salesChannel.isActive == true}).map(salesChannel => {return salesChannel.channelId})
        },
        agentsChannelOptionsChanged: function($event, salesChannel) {
            this.customAgentSelction = $event.value

            if($event.value == false){
                this.scheduleTask.agentIdList = []
            }

        },
    },
    components:{
        agentWhiteList,
        vSelect
    }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// formPartInvoice.vue?c421b3a8